import { render, staticRenderFns } from "./MultipleChoiceMultipleAnswerComponent.vue?vue&type=template&id=50fd743a&"
import script from "./MultipleChoiceMultipleAnswerComponent.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceMultipleAnswerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports